export enum TutorialStatus {
	SKIPPED = 'skipped',
	GOING = 'going',
	REVIEW = 'review',
	ENDED = 'ended',
	RESET = 'reset'
}
